/**
 * 接口
 */
import config from '@/config/index.js';
// 发送验证码
const sendVerificationCode = {
    url: '/acc/2/in/verification_code/send',
    method: 'post',
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
};
// 省份
const provincesList = {
    url: `/uds/ss/fellow/v1/provinces`,
    method: 'get',
    dataType: 'array'
};
// 城市
const citiesList = {
    url: `/uds/ss/fellow/v2/provinces/{province_id}/cities`,
    method: 'get',
    dataType: 'array'
};
// // 热门城市
// const hotCities = params => wxRequest(params, HADES_API + 'uds/in/fellow/v1/hot-cities')
// 热门城市
const hotCitiesList = {
    url: `/uds/in/fellow/v1/hot-cities`,
    // url: `/uds/ss/fellow/v1/nio-houses-cities`,
    method: 'get',
    dataType: 'array'
};

const createLeads = {
    url: `/beyonder/api/v3/leads/by-mobile-verify`,
    method: 'post',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

/**
 * 来源codes
 */
const getCompatibleCode = {
    url: `/compatibleCode`,
    method: 'get',
    serverHost: '/backend'
};

// http://showdoc.nevint.com/index.php?s=/lifestyle&page_id=19349
const decode = {
    url: `/api/2/in/lifestyle/account/user/decode`,
    method: 'get'
};

/** 获取fellow专属下载链接 https://apidoc.nioint.com/project/11730/interface/api/1384816 */
const getFellowDownloadUrl = {
    url: `/proxy/seige/v1/in/fellow/download-code`,
    method: 'get',
    requstTypeJson: true,
    serverHost: '/dino'
};

/** decode uniqueKey */
const decodeUniqueKey = {
    url: '/tools/v1/unique-key/decode',
    method: 'get',
    requstTypeJson: true,
    serverHost: '/dino'
};

/** 常规留资专用encodeUniqueKey */
const encodeLeadsUniqueKey = {
    url: '/tools/v1/unique-key/encode/leads',
    method: 'post',
    requstTypeJson: true,
    serverHost: '/dino'
};

export default {
    sendVerificationCode,
    provincesList,
    citiesList,
    hotCitiesList,
    getCompatibleCode,
    createLeads,
    decode,
    getFellowDownloadUrl,
    decodeUniqueKey,
    encodeLeadsUniqueKey
};



// WEBPACK FOOTER //
// ./src/service/leads/index.js